import { BaseButton } from '@bnnvara/buttons';
import { Grid, GridItem, GridSpacer } from '@bnnvara/grids';
import { Loading as LoadingIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Loading';
import { Heading } from '@bnnvara/typography';
import flowRight from 'lodash/flowRight';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React from 'react';

import resizeImageSource from '../../../helpers/resizeImageSource';
import NoSearchResults from '../NoSearchResults/NoSearchResults';
import SearchResultItem from '../SearchResultItem';
import LoadMoreContainerStyled from './styled';

const formatResultItem = (result) => ({
  ...result,
  brand: result.brand || 'NO BRAND',
  tags: Array.isArray(result.tags) ? result.tags : [],
  imageUrl: resizeImageSource(get(result, 'image.url', null)),
});

const FormattedSearchResultItem = flowRight(SearchResultItem, formatResultItem);

const renderHeaderText = (hits) =>
  hits === 1 ? '1 resultaat' : `${hits} resultaten`;

const SearchResults = ({
  query,
  hits,
  results,
  onLoadMore,
  initialLoading,
  loading,
  loadingMore,
}) => {
  const renderHeading = !initialLoading && results.length > 0;
  const renderResults = results.length > 0;
  const renderNoResults = !loading && query && results.length === 0;
  const renderLoadingIcon = loadingMore || (loading && results.length === 0);
  const renderLoadMoreButton = hits > results.length && !loadingMore;

  const resultsWithIndex = results.map((item, index) => ({ ...item, index }));

  return (
    <React.Fragment>
      <GridSpacer />
      <Grid>
        <GridItem columnStartSm="1" columnEndSm="12">
          {renderHeading && (
            <Heading element="h2" variant="two">
              {renderHeaderText(hits)}
            </Heading>
          )}

          {renderNoResults && <NoSearchResults query={query} />}
        </GridItem>
        {renderResults && resultsWithIndex.map(FormattedSearchResultItem)}
      </Grid>
      <LoadMoreContainerStyled>
        {renderLoadingIcon && <LoadingIcon />}
        {renderLoadMoreButton && (
          <BaseButton variant="underline" onClick={onLoadMore}>
            Toon meer
          </BaseButton>
        )}
      </LoadMoreContainerStyled>
    </React.Fragment>
  );
};

SearchResults.propTypes = {
  query: PropTypes.string.isRequired,
  hits: PropTypes.number.isRequired,
  results: PropTypes.arrayOf(PropTypes.shape()),
  onLoadMore: PropTypes.func,
  initialLoading: PropTypes.bool,
  loadingMore: PropTypes.bool,
  loading: PropTypes.bool,
};

SearchResults.defaultProps = {
  results: [],
  onLoadMore: () => {},
  initialLoading: true,
  loadingMore: false,
  loading: false,
};

export default SearchResults;
